var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainingReactToPunishmentV4(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 17.5H3.33333C2.87333 17.5 2.5 17.1266 2.5 16.6666V11.6666C2.5 11.2066 2.87333 10.8333 3.33333 10.8333H5C5.46 10.8333 5.83333 11.2066 5.83333 11.6666V16.6666C5.83333 17.1266 5.46 17.5 5 17.5Z",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 14.1666H12.7775C13.1384 14.1666 13.4892 14.05 13.7775 13.8333L15.7909 12.3233C16.2934 11.9466 16.9967 11.9966 17.4409 12.4408V12.4408C17.9342 12.9341 17.9342 13.7333 17.4409 14.2258L15.7134 15.9533C15.2484 16.4183 14.655 16.7358 14.01 16.865L11.5684 17.3533C11.0842 17.45 10.585 17.4383 10.1059 17.3183L7.89754 16.7666C7.63337 16.7 7.36254 16.6666 7.09004 16.6666H5.83337",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 14.1666H12.0709C12.7684 14.1666 13.3334 13.6016 13.3334 12.9041V12.6516C13.3334 12.0725 12.9392 11.5675 12.3775 11.4275L10.4675 10.95C10.1567 10.8725 9.83837 10.8333 9.51837 10.8333V10.8333C8.74587 10.8333 7.99004 11.0616 7.34754 11.4908L5.83337 12.5",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7408 2.935C16.9625 3.1125 17.6258 4.30667 17.48 5.30834C17.185 7.34084 13.5408 8.51 13.4792 8.50167C13.4175 8.4925 10.2575 6.33417 10.5525 4.3025C10.6983 3.30084 11.6733 2.345 12.895 2.5225C13.5933 2.62417 14.005 3.0175 14.2275 3.34667C14.5358 3.09334 15.0425 2.83334 15.7408 2.935V2.935Z",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingReactToPunishmentV4);
export default __webpack_public_path__ + "static/media/trainingReactToPunishmentV4.a6d9c891d54b89aa9f41ec1ab3079010.svg";
export { ForwardRef as ReactComponent };